import { render, staticRenderFns } from "./RegistrationLocation.vue?vue&type=template&id=1ad987b7"
import script from "./RegistrationLocation.vue?vue&type=script&lang=js"
export * from "./RegistrationLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports